// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Types
import {
  PaymentLandingFormMethodsHandlersType,
  PaymentLandingFormBuilderHandlersType,
  PaymentLandingFormSuccessBuilderHandlersType,
} from './types/payment-landing-form.polling.handlers.type';
import { GetStateSuccessType } from 'types/get-state-success.type';

const manageReceivedDataFromKycWSEventHandler = ({
  state,
  setCurrentState,
  setError,
}: PaymentLandingFormSuccessBuilderHandlersType): void => {
  switch (state) {
    case AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING:
      break;
    case AppStatesEnumeration.CHECKOUT_SIGNED_PENDING:
    case AppStatesEnumeration.CHECKOUT_SIGNED:
      setCurrentState(state);
      break;
    default:
      setError(AppErrorEnumeration.PAYMENT_WS_ERROR);
  }
};

const managePaymentErrorStatePollingEventHandler = (
  setError: PaymentLandingFormBuilderHandlersType['setError']
): void => {
  setError(AppErrorEnumeration.PAYMENT_WS_ERROR);
};

const PaymentLandingFormPollingHandlers = ({
  setError,
  ...props
}: PaymentLandingFormBuilderHandlersType): PaymentLandingFormMethodsHandlersType => ({
  handleManagePaymentErrorStatePollingEvent: () =>
    managePaymentErrorStatePollingEventHandler(setError),
  handleManagePaymentSuccessStatePollingEvent: (response: GetStateSuccessType) =>
    manageReceivedDataFromKycWSEventHandler({ ...response, ...props, setError }),
});

export { PaymentLandingFormPollingHandlers };
